// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"bfa5af5c","306":"d9e8e355","320":"b2838863","388":"53993619","500":"c0a900ef","632":"56e58b8f","792":"1a7d5d2f"}[chunkId] + ".chunk.js";
};